import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginPage from "../views/Guest/Login.vue";
import anasayfa from '../views/Anasayfa.vue';
import {store} from "@/store";
import Guards from "./guards";
Vue.use(VueRouter)

const routes = [
    //{path: '/', redirect:'/login'},
    {
        path: '/login',
        component: LoginPage,
        beforeEnter: Guards.guestOnly,
        meta: {
            title: "Login",
        }
    },
    //DM routes
    {
        path: '/category/category',
        component: () => import('@/views/Category/Category.vue')
    },
    {
        path: '/category/show',
        component: () => import('@/views/Category/CategoryShow.vue')
    },
    /*
    Urunler
     */
    {
        path: '/urunayarlari/urunler',
        component: () => import('@/views/Product/Product.vue')
    },
    {
        path: '/urunayarlari/urun/:product_id',
        component: () => import('@/views/Product/ProductEditNormal.vue')
    },
    {
        path: '/urunayarlari/urunvaryasyon/',
        component: () => import('@/views/Product/ProductVariant.vue')
    },
    {
        path: '/urunayarlari/urunvaryasyon/:product_sku_id',
        component: () => import('@/views/Product/ProductVariantOptions.vue')
    },
    /*
    Genel
     */
    {
        path: '/genel/comments',
        component: () => import('@/views/Genel/Comments.vue')
    },
    {
        path: '/yonetim/googleutm',
        component: () => import('@/views/Yonetim/GoogleUtm.vue')
    },
    {
        path: '/yonetim/duyurular',
        component: () => import('@/views/Yonetim/Duyurular.vue')
    },
    {
        path: '/yonetim/bilgilendirme',
        component: () => import('@/views/Yonetim/Bilgilendirme.vue')
    },
    {
        path: '/genel/pages',
        component: () => import('@/views/Genel/Pages.vue')
    },
    {
        path: '/genel/blog',
        component: () => import('@/views/Genel/Blog.vue')
    },
    {
        path: '/genel/users',
        component: () => import('@/views/Genel/Users.vue')
    },
    {
        path: '/genel/bayiler',
        component: () => import('@/views/Genel/Dealers.vue')
    },
    /*
    Site aayarlari
     */
    {
        path: '/ayarlar/siteconfig',
        component: () => import('@/views/SiteAyarlari/SiteConfig.vue')
    },
    {
        path: '/ayarlar/homecards',
        component: () => import('@/views/SiteAyarlari/HomeCards.vue')
    },
    {
        path: '/ayarlar/sozlesmeler',
        component: () => import('@/views/SiteAyarlari/Sozlesmeler.vue')
    },
    {
        path: '/ayarlar/slider',
        component: () => import('@/views/SiteAyarlari/Slider.vue')
    },
    {
        path: '/ayarlar/banner',
        component: () => import('@/views/SiteAyarlari/Banner.vue')
    },
    {
        path: '/ayarlar/cargo',
        component: () => import('@/views/SiteAyarlari/Cargo.vue')
    },
    {
        path: '/ayarlar/paymenttypes',
        component: () => import('@/views/SiteAyarlari/PaymentTypes.vue')
    },
    {
        path: '/ayarlar/sanalpos',
        component: () => import('@/views/SiteAyarlari/SanalPos.vue')
    },
    {
        path: '/ayarlar/havalebilgileri',
        component: () => import('@/views/SiteAyarlari/Havale.vue')
    },
    {
        path: '/ayarlar/rules',
        component: () => import('@/views/SiteAyarlari/Rules.vue')
    },
    {
        path: '/ayarlar/sablon',
        component: () => import('@/views/SiteAyarlari/Sablon.vue')
    },
    {
        path: '/ayarlar/seosettings',
        component: () => import('@/views/SiteAyarlari/SeoSettings.vue')
    },
    {
        path: '/ayarlar/kurulumlar',
        component: () => import('@/views/SiteAyarlari/Kurulumlar.vue')
    },
    /*
    Kampanya
     */
    {
        path: '/kampanya/coupon',
        component: () => import('@/views/Kampanya/Coupon.vue')
    },
    {
        path: '/kampanya/discount',
        component: () => import('@/views/Kampanya/Discount.vue')
    },
    {
        path: '/kampanya/splash',
        component: () => import('@/views/Kampanya/Splash.vue')
    },
    {
        path: '/kampanya/kampanyalar',
        component: () => import('@/views/Kampanya/Kampanyalar.vue')
    },

    /*
    Sikça Sorulan Sorular
     */
    {
        path: '/sss/sikcaSorulanSorular',
        component: () => import('@/views/Sss/SikcaSorulanSorular.vue')
    },

    /*
    Kullanım Kılavuzu
     */
    {
        path: '/kk/kullanimKilavuzu',
        component: () => import('@/views/Kk/KullanimKilavuzu.vue')
    },
    /*
    Siparisler
     */
    {
        path: '/siparis/sepetolustur',
        component: () => import('@/views/Order/CreateBasket.vue')
    },
    {
        path: '/siparis/detay/:order_id',
        component: () => import('@/views/Order/OrderEdit.vue')
    },
    {
        path: '/siparis/:statustext/:status',
        component: () => import('@/views/Order/Order.vue')
    },
    /*
    Yönetim
     */
    {
        path: '/yonetim/logs',
        component: () => import('@/views/Yonetim/Logs.vue')
    },
    {
        path: '/yonetim/jobs',
        component: () => import('@/views/Yonetim/Jobs.vue')
    },
    {
        path: '/yonetim/tenant-havuzu',
        component: () => import('@/views/Yonetim/TenantHavuzu.vue')
    },
    /*
    Kullanıcılar
     */
    {
        path: '/kullanicilar/tum-kullanicilar',
        component: () => import('@/views/Kullanicilar/TumKullanicilar.vue')
    },
    {
        path: '/kullanicilar/musteri',
        component: () => import('@/views/Kullanicilar/Musteri.vue')
    },
    {
        path: '/kullanicilar/lisansi-bitmis-kullanicilar',
        component: () => import('@/views/Kullanicilar/Musteri.vue')
    },
    /*
    İcraproWeb
     */
    {
        path: '/icraproWeb/hesaplar',
        component: () => import('@/views/IcraproWeb/Hesaplar.vue')
    },
    {
        path: '/icraproWeb/icra-dairesi-mahkeme',
        component: () => import('@/views/IcraproWeb/IcraDairesiMahkeme.vue')
    },
    {
        path: '/icraproWeb/noterler',
        component: () => import('@/views/IcraproWeb/Noterler.vue')
    },
    {
        path: '/icraproWeb/harclar',
        component: () => import('@/views/IcraproWeb/Harclar.vue')
    },
    {
        path: '/icraproWeb/masraflar',
        component: () => import('@/views/IcraproWeb/Masraflar.vue')
    },
    {
        path: '/icraproWeb/faizler',
        component: () => import('@/views/IcraproWeb/Faizler.vue')
    },
    {
        path: '/icraproWeb/ihyitati-haciz',
        component: () => import('@/views/IcraproWeb/IhtiyatiHaciz.vue')
    },
    {
        path: '/icraproWeb/banka',
        component: () => import('@/views/IcraproWeb/Bankalar.vue')
    },
    {
        path: '/icraproWeb/yargi-birimi',
        component: () => import('@/views/IcraproWeb/YargiBirimi.vue')
    },
    {
        path: '/icraproWeb/loglar',
        component: () => import('@/views/IcraproWeb/Logs.vue')
    },
    {
        path: '/icraproWeb/gece-kosusu',
        component: () => import('@/views/IcraproWeb/GeceKosusu.vue')
    },
    {
        path: '/icraproWeb/gece-kosusu/:kosuId',
        component: () => import('@/views/IcraproWeb/GeceKosusuDetay.vue')
    },
    /*
   Arabulucu
    */
    {
        path: '/arabulucu/uyusmazlik-turleri',
        component: () => import('@/views/Arabulucu/UyusmazlikTurleri.vue')
    },
    {
        path: '/arabulucu/dava-turleri',
        component: () => import('@/views/Arabulucu/DavaTurleri.vue')
    },
    /*
    Anket & Değerlendirme
    */
    {
        path: '/anket/degerlendirme',
        component: () => import('@/views/Survey/Survey.vue')
    },
    {
        path: '/anket/anket-ayarlari',
        component: () => import('@/views/Survey/SurveySettings.vue')
    },
    {path: '/Anasayfa', component: anasayfa},
    //{path: '/', redirect:'/Anasayfa'},
];


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})
router.afterEach((to, from) => {
    // ...
    store.dispatch("breadcrumb");
})
export default router
